window.addEventListener('DOMContentLoaded', function() {

    hashChangeCurrentItems(); // 初始化效果
    // 路由监听 监听窗口链接的hash值变化
    window.addEventListener('hashchange', function() {
        hashChangeCurrentItems();
    });

    // 点击下拉菜单
    const dropdownBtn = document.getElementById('topic-dropdown');
    const dropdownContent = document.getElementById('dropdown-content');
    const height = dropdownContent.querySelector('ul').offsetHeight;
    const filterIcon = dropdownBtn.querySelector('.filter-icon');

    dropdownBtn.addEventListener('click', function() {
        dropdownContent.classList.toggle('open');
        filterIcon.classList.toggle('open');
        if (dropdownContent.classList.contains('open')) {
            dropdownContent.style.height = height + 'px';
        } else {
            dropdownContent.style.height = 0;
        }
    });

    // 点击泡泡滑动出右侧栏
    document.addEventListener('click', e => {
        const Bubble = e.target.closest('.faq-sidebar-right');
        const contactBubble = document.getElementById('shopify-section-faq-side-bar-right');
        
        if (Bubble) {
            contactBubble.classList.add('active');
        } else {
            contactBubble.classList.remove('active');
        }
    });

});

// 激活侧边栏效果
function hashChangeCurrentItems() {
    const currentHash = window.location.hash.substring(1); // 获取当前锚点，去掉#号
    const topicItems = document.querySelectorAll('.faq-sidebar-link');
    if (currentHash === '') {
        topicItems[0].classList.add('current');
    } else {
        topicItems.forEach(item => {
        const href = item.getAttribute('href').substring(1); // 获取链接的锚点部分，去掉#号
        if (href === currentHash) {
            item.classList.add('current');
        } else {
            item.classList.remove('current');
        }
    });
    }
}